import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MtnaDenseOutlineSelectModule } from '@mtna/core-i18n-angular';

import { RdsAppToolbarComponent } from './app-toolbar.component';

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    FormsModule,
    MatButtonModule,
    MatDividerModule,
    MatIconModule,
    MatMenuModule,
    MatToolbarModule,
    MtnaDenseOutlineSelectModule,
  ],
  exports: [RdsAppToolbarComponent],
  declarations: [RdsAppToolbarComponent],
})
export class RdsAppToolbarModule {}

export * from './app-toolbar.component';
